import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/material',
  name: 'Material',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/material',
      component: () => import('@/views/operation/materialManage/index.vue'),
      meta: {
        title: '素材库管理',
        icon: 'material'
      }
    },
    {
      path: '/operation/material/:id',
      component: () => import('@/views/operation/materialManage/detail.vue'),
      meta: {
        title: '素材详情'
      }
    }
  ]
}
